import React, { Suspense } from 'react'
import Field from '../../../fields'
import { colors } from '@lmc/common/constants'

interface EmarMedicationInstructionsSectionProps {
  fields: Record<string, any>
  formId: string
  resident: Record<string, any>
}

const renderCautionaryInstructionsField = (
  props: EmarMedicationInstructionsSectionProps
) => {
  const { fields, formId } = props

  const title = 'Cautionary Instructions'
  const note =
    'Written on the pharmacy label. This will be shown to carers whilst they are administering medication.'

  const renderLabelChildren = () => <div style={styles.labelNote}>{note}</div>

  return (
    <div style={styles.fieldContainer}>
      <Suspense fallback={<div>Loading...</div>}>
      <Field
        compact
        displayLabel
        fieldType="textarea"
        formId={formId}
        keys="cautionaryInstructions"
        layout="no-label"
        label={title}
        renderLabelChildren={renderLabelChildren}
        style={{ resize: 'none' }}
        type="userGeneratedFieldLayout"
        values={fields}
      />
      </Suspense>
    </div>
  )
}

const EmarMedicationInstructionsSection: React.FC<
  EmarMedicationInstructionsSectionProps
> = (props) => {
  return <div>{renderCautionaryInstructionsField(props)}</div>
}

const styles = {
  fieldContainer: {
    marginTop: 16,
  },
  labelNote: {
    color: colors.darkgrey,
    fontSize: 12,
    lineHeight: '18px',
  },
}

export default EmarMedicationInstructionsSection
